import axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL

const token = sessionStorage.getItem('token')
axios.defaults.headers.common.Authorization = `Bearer ${token}`

async function payLink(type, hash, data) {
  try {
    const response = await axios.post(`${BASE_URL}${type}/${hash}`, data);
    return response;
  } catch (error) {
    console.error('axios error response:', error.response);
    return error.response || error;
  }
}

async function getLink(type, hash) {
  try {
    const response = await axios.get(`${BASE_URL}${type}/${hash}`)
    return response
  } catch ({ response }) {
    // window.location.href = '/error-404'
    return response
  }
}

async function getPaymentLinkError(hash) {
  try {
    return await axios.post(`${BASE_URL}payment-link-error/${hash}`)
  } catch (error) {
    return error.response || error
  }
}

async function getPixQRCode(hash,payload) {
  try {
    return await axios.post(`${BASE_URL}payment-link/pix/${hash}`, payload)
  } catch (error) {
    return error.response || error
  }
}

export {
  payLink,
  getLink,
  getPaymentLinkError,
  getPixQRCode
}
